import { gsap } from '../global/gsap';

const initProjectScroll = (element) => {
    const track = element.querySelector('.js-project-track');
    const cards = track.querySelectorAll('.project-card');

    const distance = () => {
        const lastItemBounds = cards[cards.length - 1].getBoundingClientRect();
        const containerBounds = track.getBoundingClientRect();
        return Math.max(0, lastItemBounds.right - containerBounds.right);
    };

    gsap.to(track, {
        x: () => -distance(),
        ease: 'none',
        scrollTrigger: {
            trigger: element,
            start: 'bottom bottom',
            end: () => `+=${distance()}`,
            pin: true,
            scrub: true,
            invalidateOnRefresh: true
        }
    });
};

export { initProjectScroll as default };
